import styled from 'styled-components';

export const OurAwardsWrapper = styled.section`
  max-width: 1170px;
  margin: 0px auto;
  position: relative;
  background-color: #fff;
  padding-top: 100px;
  padding-bottom: 100px;
  @media (max-width: 1200px) {
    padding-top: 80px;
    padding-bottom: 80px;
  }
  @media (max-width: 992px) {
    padding-top: 50px;
    padding-bottom: 50px;
  }
`;
export const OurAwardsDesktopWrapper = styled.div`
  display: block;
  @media (max-width: 767px) {
    display: none;
  }
`;
export const OurAwardsWrapperHeading = styled.h2`
  text-align: center;
  color: #000;
  font-size: 30px;
  line-height: 30px;
  font-weight: 400;
  margin-bottom: 0px;
  @media (max-width: 1199px) {
    font-size: 26px;
    line-height: 30px;
    margin-bottom: 0px;
  }
  @media (max-width: 768px) {
    font-size: 20px;
    line-height: 30px;
    margin-bottom: 0;
  }
`;
export const OurAwardsBody = styled.div`
  padding-top: 50px;
  position: relative;
  @media (max-width: 1200px) {
    padding-right: 20px;
    padding-left: 20px;
  }
  .swiper-header-section {
    position: relative;
  }
  @media (max-width: 992px) {
    padding-top: 25px;
  }
  .swiper-section {
    overflow: hidden;
  }
  .swiper {
    margin-right: -2px;
    margin-left: 1px;
    .swiper-slide-active {
      h5 {
        color: #3b79d6;
      }
    }
  }
`;
export const SliderContenSection = styled.div`
  padding-top: 50px;
  .seperator {
    height: 1px;
    width: 100%;
    background-color: #ccc;
  }
  &.mobile-tab {
    display: none;
  }
  &.active-tab {
    display: block !important;
  }
  @media (max-width: 1024px) {
    padding-top: 20px;
  }
  @media (max-width: 767px) {
    padding-top: 10px;
  }
`;
export const OurAwardsSlider = styled.div`
  position: relative;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  &:before {
    content: '';
    position: absolute;
    background-color: #b4b4b4;
    height: 20px;
    width: 2px;
    right: 0%;
    top: 2px;
  }
  &[dir='ltr'] {
    &:last-child {
      &:before {
        content: '';
        display: none;
      }
    }
  }
  &[dir='rtl'] {
    &:first-child {
      &:before {
        content: '';
        display: none;
      }
    }
  }
`;
export const OurAwardsTab = styled.h5`
  font-size: 16px;
  color: #b4b4b4;
  line-height: 20px;
  font-weight: 500;
  text-transform: uppercase;
  margin: 0px;
  cursor: pointer;
  padding-right: 10px;
  padding-left: 10px;
  position: relative;
  @media (max-width: 1200px) {
    font-size: 15px;
    padding-right: 35px;
    padding-left: 35px;
  }
  @media (max-width: 992px) {
    font-size: 14px;
    padding-right: 20px;
    padding-left: 20px;
  }
  &.active-tab {
    color: #3b79d6;
  }
`;
export const OurAwardsLogo = styled.div`
  height: 108px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #c1c1c1;
  img {
    max-height: 90px;
  }
`;
export const OurAwardDescription = styled.div`
  max-width: 370px;
  display: flex;
  flex-direction: row;
  row-gap: 20px;
  color: #575757;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  @media (max-width: 1200px) {
    max-width: 500px;
  }
  div {
    width: calc(50% - 10px);
    font-size: 14px;
    line-height: 20px;
    color: #575757;
    @media (max-width: 767px) {
      text-align: left;
    }
    span {
      color: #3b79d6;
    }
    p {
      margin: 0px;
    }
  }
`;
export const SliderContentWrapper = styled.div`
  padding-top: 50px;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  @media (max-width: 1024px) {
    flex-direction: column;
    row-gap: 20px;
    padding-top: 20px;
  }
  h3 {
    margin: 0px;
    font-size: 20px;
    color: #000;
    line-height: 28px;
    max-width: 570px;
    @media (max-width: 767px) {
      max-width: 100%;
      font-size: 15px;
      line-height: 21px;
      text-align: left;
    }
  }
`;
export const SliderPrevButton = styled.button`
  outline: none;
  border: none;
  border-radius: 50%;
  background-color: transparent;
  height: 20px;
  display: flex;
  align-items: center;
  position: absolute;
  top: 0%;
  left: -30px;
  cursor: pointer;
  z-index: 10;
  svg {
    width: 11px;
    height: 11px;
  }
  @media (max-width: 1500px) {
    svg {
      width: 10px;
    }
  }
  @media (max-width: 1500px) {
    left: -10px;
  }
`;
export const SliderNextButton = styled.button`
  outline: none;
  border: none;
  border-radius: 50%;
  background-color: transparent;
  height: 20px;
  display: flex;
  align-items: center;
  position: absolute;
  top: 0%;
  right: -30px;
  cursor: pointer;
  z-index: 10;
  svg {
    width: 11px;
    height: 11px;
  }
  @media (max-width: 1500px) {
    svg {
      width: 10px;
    }
  }
  @media (max-width: 1500px) {
    right: -10px;
  }
`;
export const OurAwardsPagination = styled.div`
  margin-top: 40px;
  @media (max-width: 992px) {
    margin-top: 30px;
  }
  display: flex;
  justify-content: center;
  align-items: center;
  &[dir='rtl'] {
    ul {
      li {
        svg {
          transform: rotate(180deg);
        }
      }
    }
  }
  ul {
    display: flex;
    padding: 0px;
    margin: 0px;
    li {
      list-style: none;
      width: 30px;
      height: 30px;
      color: #b3b3b3;
      font-size: 12px;
      font-weight: 700;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      &.selected {
        background-color: #3b79d6;
        color: #fff;
        a {
          color: #fff !important;
        }
      }
      a {
        color: #b3b3b3;
        display: flex;
        width: 30px;
        height: 30px;
        justify-content: center;
        align-items: center;
        svg {
          width: 12px;
          height: 12px;
          path {
            fill: #000;
          }
        }
      }
    }
  }
`;
export const AwardsMobileWrapper = styled.section`
  background-color: #fff;
  display: block;
  @media (min-width: 768px) {
    display: none;
  }
`;
export const AwardsMobileContainer = styled.div`
  max-width: 1696px;
  margin: 0 auto;
  position: relative;
  text-align: center;
  padding: 0px 15px;
`;
export const AwardsMobileHeader = styled.div`
  h2 {
    color: #000;
    font-size: 14px;
    line-height: 14px;
    margin: 0px;
  }
`;
export const AwardsMobileTabHeaderWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;
export const AwardsMobileTab = styled.h5`
  margin: 0px;
  text-transform: uppercase;
  border: 1px solid #e6e6e6;
  background: var(--white, #fff);
  color: #4a4a4a;
  font-size: 11px;
  font-weight: 500;
  line-height: 1;
  text-align: center;
  font-weight: 500;
  cursor: pointer;
  padding: 8px 12px;
  &.active-tab {
    background-color: #3b79d6;
    color: #fff !important;
  }
`;
export const AwardsMobileBody = styled.div`
  padding-top: 20px;
  .swiper-wrapper {
    .swiper-slide {
      position: relative;
      padding-right: 20px;
      padding-left: 20px;
      padding-top: 15px;
      padding-bottom: 15px;
      border: 2px solid #b4b4b4;
      &.swiper-slide-active {
        .mobile-tab {
          color: #3b79d6;
        }
      }
    }
  }
`;
